<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-12-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-navbar variant="light" type="light" fixed="top" toggleable="lg">
    <b-navbar-brand :to="{ path: '/home' }">
      <img :src="logoUrl" style="height:30px" alt="home">
    </b-navbar-brand>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item :to="{name:'product_category_selection_path', params: {}}">Products</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item :to="{name:'part_search_path'}">Part Search</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item :to="{name:'quote_path'}">Quote Summary</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item @click="handleNewQuote" >New Quote</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-navbar-nav>
          <b-nav-item @click="handleSignOut" >Sign In</b-nav-item>
        </b-navbar-nav>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import logo from "../../../images/dynabook_black.jpg"
import NavigationMixin from "../../../components/yega/mixins/navigation-mixin"

export default {
  name: "navigation",
  mixins: [NavigationMixin],
  data(){
    return {
      CurrentUserStore:this.$store.state.CurrentUserStore,
      logoUrl:logo
    }
  },
  methods:{
    handleNewQuote(){
      this.$store.dispatch('CurrentUserStore/show',{show_new_quote_id:'YES'})
          .then((item)=>{
            this.$router.push({path: '/home'});
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    }
  }
}
</script>

<style scoped>

</style>
